import React from 'react';

function Logo() {
  const handleLogoDoubleClick = () => {
    localStorage.removeItem('zuta');
    localStorage.removeItem('uname');
    window.location.reload();
  };

  return (
    <img
      src="./build/pics/logo.svg"
      alt="Logo"
      className="logoGrow"
      onDoubleClick={handleLogoDoubleClick}
    />
  );
}

export default Logo;
